import Button from "../../Elements/Button/Button.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";

interface CallToActionSubscribeI {
  isOpen: () => void;
  subscribeOnly: boolean;
}

const CallToActionSubscribe = ({
  isOpen,
  subscribeOnly,
}: CallToActionSubscribeI) => {
  const { getTextByKey } = useContent();

  const storageBenefitsList = [
    {
      icon: "clock-gradient",
      label: getTextByKey("no-expiration-label"),
    },
    {
      icon: "lock-gradient",
      label: getTextByKey("protected-label"),
    },
    {
      icon: "inbox-stack-gradient",
      label: getTextByKey("available-label"),
    },
  ];

  return (
    <div className="save-mail left-section">
      <div className="left-section-title-container">
        <div className="save-mail-description-container">
          <Icon name="jm-marketing-icon" iconClass="save-mail-icon" />
          <p>{getTextByKey("for-subscribers")}</p>
        </div>
        <div className="save-mail-title">
          {getTextByKey("save-mail-modal-subscribe-title")}
        </div>
      </div>
      <div className="save-mail-sub-title">
        {getTextByKey("save-mail-modal-subscribe-subtitle")}
      </div>

      <div className="storage-benefits-section">
        <Image
          name="save-files-forever"
          ext="png"
          className="storage-benefits-image"
        />
        <ul className="storage-benefits-list">
          {storageBenefitsList.map((item) => (
            <li key={item.icon} className="storage-benefits-item">
              <div className="storage-benefits-icon-wrap">
                <Icon name={item.icon} iconClass="storage-benefits-icon" />
              </div>
              <p className="storage-benefits-text">{item.label}</p>
            </li>
          ))}
        </ul>
      </div>

      <p className="save-mail-sub-title">
        {getTextByKey("save-mail-upgrade-description")}
      </p>

      <div className="save-mail-actions-container">
        <LinkToNewTab page={"plans"} isNewTab={true}>
          <Button fullwidth medium className="save-mail-btn">
            <Icon name="jm-marketing-icon" iconClass="save-mail-icon" />
            {getTextByKey("upgrade").charAt(0).toUpperCase() +
              getTextByKey("upgrade").slice(1)}
          </Button>
        </LinkToNewTab>
        {!subscribeOnly && (
          <button className="have-jumbocode-btn" onClick={isOpen}>
            {getTextByKey("have-jumbocode")}
          </button>
        )}
      </div>
    </div>
  );
};
export default CallToActionSubscribe;
